import {
  PROPOSE_LIST_SEARCH, PROPOSE_LIST_SEARCH_FAILURE, PROPOSE_LIST_SEARCH_SUCCESS,
  PROPOSE_COUNT, PROPOSE_COUNT_FAILURE, PROPOSE_COUNT_SUCCESS,
  SHOP_DETAIL, SHOP_DETAIL_FAILURE, SHOP_DETAIL_SUCCESS,
  PROPOSE_KEYWORD_SEARCH, PROPOSE_KEYWORD_SEARCH_FAILURE, PROPOSE_KEYWORD_SEARCH_SUCCESS,
  GET_REJECTED_COUNT, GET_REJECTED_COUNT_FAILURE, GET_REJECTED_COUNT_SUCCESS,
  PROPOSE_DELETE, PROPOSE_DELETE_FAILURE, PROPOSE_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposes: [],
    proposeTotalCount: null,
    proposeNextPage: null,
    proposeCurrentPage: null,
    proposeListLoading: true,
    shop: null,
    shops: null,
    users: null,
    rejectedCount: 0
  },
  getters: {
    proposeTotalCount: state => {
      return state.proposeTotalCount
    },
    proposeList: state => {
      return state.proposes
    },
    shopDetail: state => {
      return state.shop
    },
    keywordShops: state => {
      return state.shops
    },
    keywordUsers: state => {
      return state.users
    },
    rejectedCount: state => {
      return state.rejectedCount
    },
    proposeNextPage: state => {
      return state.proposeNextPage
    },
    proposeCurrentPage: state => {
      return state.proposeCurrentPage
    },
    proposeListLoading: state => {
      return state.proposeListLoading
    },
    nextPage: state => {
      return state.proposeNextPage
    }
  },
  actions: {
    [PROPOSE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/proposes'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PROPOSE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_COUNT] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/asovi/proposes/count', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_COUNT_FAILURE, res.data)
          } else {
            commit(PROPOSE_COUNT_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/master/shops/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(SHOP_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_KEYWORD_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/proposes/keyword'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_KEYWORD_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PROPOSE_KEYWORD_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_REJECTED_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/proposes/get_rejected_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_REJECTED_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_REJECTED_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_DELETE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiDelete', {url: '/asovi/proposes/' + params.id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_DELETE_FAILURE, res.data)
          } else {
            commit(PROPOSE_DELETE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('PROPOSE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('PROPOSE_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.proposes = data.data
        if (data.meta['next-page'] === null) {
          state.proposeNextPage = null
        }
      } else {
        state.proposeListLoading = false
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.proposes = state.proposes.concat(data.data)
          state.proposeCurrentPage = data.meta['current-page']
        } else if (data.meta && data.meta['current-page'] && data.meta['current-page'] === 1) {
          state.proposes = data.data
          state.proposeCurrentPage = 1
        } else {
          state.proposes = data.data
          state.proposeCurrentPage = null
        }
        if (data.links && data.links['next']) {
          state.proposeNextPage = data.links['next']
        } else {
          state.proposeNextPage = null
        }
      }
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_COUNT_FAILURE] (state, data) {
      console.log('PROPOSE_COUNT_FAILURE')
    },
    [PROPOSE_COUNT_SUCCESS] (state, data) {
      console.log('PROPOSE_COUNT_SUCCESS')
      state.proposeTotalCount = data.data
    },
    [SHOP_DETAIL_FAILURE] (state, data) {
      console.log('SHOP_DETAIL_FAILURE')
    },
    [SHOP_DETAIL_SUCCESS] (state, data) {
      console.log('SHOP_DETAIL_SUCCESS')
      state.shop = data.data
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_KEYWORD_SEARCH_FAILURE] (state, data) {
      console.log('PROPOSE_KEYWORD_SEARCH_FAILURE')
    },
    [PROPOSE_KEYWORD_SEARCH_SUCCESS] (state, data) {
      console.log('PROPOSE_KEYWORD_SEARCH_SUCCESS')
      state.shops = data.data.shops.data
      state.users = data.data.users.data

      if (data.callback) {
        data.callback()
      }
    },
    [GET_REJECTED_COUNT_FAILURE] (state, data) {
      console.log('GET_REJECTED_COUNT_FAILURE')
    },
    [GET_REJECTED_COUNT_SUCCESS] (state, data) {
      console.log('GET_REJECTED_COUNT_SUCCESS')
      state.rejectedCount = data.count
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_DELETE_FAILURE] (state, data) {
      console.log('PROPOSE_DELETE_FAILURE')
    },
    [PROPOSE_DELETE_SUCCESS] (state, data) {
      console.log('PROPOSE_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-list.js